module.exports = require("react-collapse");


//////////////////
// WEBPACK FOOTER
// external "react-collapse"
// module id = 277
// module chunks = 0